export default "__VITE_ASSET__BA0_Gu_7__"